import React, { HTMLProps, ReactNode } from 'react';
import Tippy from '@tippyjs/react';
import { Placement } from 'tippy.js';

export const Tooltip: React.FC<
    {
        tooltipTitle?: string;
        tooltipText?: string;
        tooltipElement?: ReactNode;
        place?: Placement;
    } & HTMLProps<HTMLDivElement>
> = ({ className, tooltipTitle, tooltipText, tooltipElement, place = 'top', children }) => {
    const content = (
        <>
            {tooltipTitle && <div className="text-base sm:text-lg pb-2 font-medium">{tooltipTitle}</div>}
            <div className="text-xs sm:text-sm">{tooltipElement ? tooltipElement : tooltipText}</div>
        </>
    );

    return (
        <Tippy
            placement={place}
            content={content}
            interactive
            className="relative bg-white text-black px-5 py-3 rounded-xl border-bnd-amber border-2"
        >
            <button className={`cursor-pointer m-2 ${className}`}>{children}</button>
        </Tippy>
    );
};
